import React from 'react'
import { Route, Switch } from 'react-router-dom'

import './App.css'
import CounselingCenter from './containers/CounselingCenter/CounselingCenter'
import Consultant from './containers/Consultant/Consultant'
import Payment from './containers/Payment/Payment'

function App() {

	return (
		<div className="App">
			<Switch>
				<Route path="/consultants/payment/verify" component={Payment}/>

				<Route path="/consultants/:counselingCenterUsername" exact component={CounselingCenter}/>
				<Route path="/consultants/:counselingCenterUsername/:consultantUsername" component={Consultant}/>
			</Switch>
		</div>
	)
}

export default App
